import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';

type Response = {};
type Variables = { id: string };

export const useCustomerPaymentMethodCreate = createMutation<
  Response,
  Variables,
  AxiosError
>({
  mutationFn: async ({ id }) =>
    client({
      url: `v2/customers/payment-methods`,
      method: 'POST',
      data: { id },
    })
      .then((response) => response.data.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
